import { TFunction } from 'i18next'
import { FC, Fragment } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { updateApplicationStatusByCode } from '../../../../actions/applications'
import { closeDialog } from '../../../../actions/dialogs'
import {
  UpdateApplicationStatusByCode,
  CloseDialog
} from '../../../../actions/types'
import { Message } from '../../../../components/Messages'
import { ApplicationStatus } from '../../../../types/applications'
import { StateInterface } from '../../../../types/states'
import { bindSubmitActionToPromise } from '../../../../utils/forms'
import UpdateApplicationStatusByCodeForm from '../../../Application/Forms/UpdateApplicationStatusByCodeForm'
import Dialog from '../../../Dialog'

interface DispatchProps {
  updateApplicationStatusByCodeAction?: UpdateApplicationStatusByCode
  closeDialogAction?: CloseDialog
}

interface OwnProps {
  status: 'noAvailableTimes' | 'notInterested'
  noReservablesCase: boolean
  t: TFunction
  buttonClassName?: any
  noOpenDialogButton?: boolean
}

type UpdateStatusDialogProps = DispatchProps & OwnProps

/** 3 cases
 *
 * 1: No available times when there are reservables
 * 2: No available times when there are no reservables
 * 3: Not interested dialog
 */
const UpdateStatusDialog: FC<UpdateStatusDialogProps> = ({
  updateApplicationStatusByCodeAction,
  status,
  t,
  noReservablesCase,
  buttonClassName,
  closeDialogAction,
  noOpenDialogButton
}) => (
  <Dialog
    dialogId={
      status === 'noAvailableTimes'
        ? 'ConfirmNoAvailableTimes'
        : 'ConfirmNotInterested'
    }
    title={t('general.confirm')}
    noOpenDialogButton={noOpenDialogButton}
    buttonLabel={t(
      noReservablesCase
        ? 'showings.reserve.noReservables.button'
        : `showings.reserve.updateStatus.${status}.button`
    )}
    buttonFullWidth
    buttonClassName={buttonClassName}
    color={status === 'noAvailableTimes' ? 'inherit' : 'secondary'}
    Content={
      <Fragment>
        <Message
          message={t(
            noReservablesCase
              ? 'showings.reserve.noReservables.message'
              : `showings.reserve.updateStatus.${status}.confirm`
          )}
          variant='body1'
        />
        <UpdateApplicationStatusByCodeForm
          updateByCode={updateApplicationStatusByCodeAction}
          byCodeStatus={
            status === 'noAvailableTimes'
              ? ApplicationStatus.noAvailableTimes
              : ApplicationStatus.notInterested
          }
          closeDialog={closeDialogAction}
          t={t}
          initialValues={{
            status:
              status === 'noAvailableTimes'
                ? ApplicationStatus.noAvailableTimes
                : ApplicationStatus.notInterested
          }}
        />
      </Fragment>
    }
  />
)

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeDialogAction: (dialogId: string) => dispatch(closeDialog(dialogId)),
  updateApplicationStatusByCodeAction: bindSubmitActionToPromise(
    dispatch,
    updateApplicationStatusByCode
  )
})

export default connect<null, DispatchProps, OwnProps, StateInterface>(
  null,
  mapDispatchToProps
)(UpdateStatusDialog)
